import React from 'react';

const ButtonOutline = ({ label, onClick = () => {}, className }) => {
  return (
    <button
      onClick={onClick}
      className={`${className} fredoka box-border inline-flex h-12 w-full items-center justify-center gap-2 rounded-2xl border border-[#FC823E] px-6 text-base font-semibold leading-normal text-[#FC823E]`}
    >
      {label}
    </button>
  );
};

export default ButtonOutline;
